var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00067 11.8503C7.4265 11.8503 6.15036 10.5742 6.15036 9C6.15036 7.42584 7.4265 6.14973 9.00067 6.14973C10.5748 6.14973 11.851 7.42584 11.851 9C11.851 10.5742 10.5748 11.8503 9.00067 11.8503ZM14.6846 7.76958C14.5351 7.0737 14.2613 6.42401 13.8872 5.84512L14.6391 5.09316L12.9033 3.35869L12.152 4.11002C11.5731 3.7359 10.9235 3.4621 10.2276 3.31261V2.25H7.77374V3.31261C7.07786 3.4621 6.42821 3.7359 5.84932 4.11002L5.09799 3.35869L3.36226 5.09316L4.11418 5.84512C3.74006 6.42401 3.46626 7.0737 3.31674 7.76958H2.25133L2.25 10.2234H3.3167C3.46622 10.9193 3.74002 11.569 4.11414 12.1479L3.35935 12.9027L5.09383 14.6384L5.84924 13.883C6.42817 14.2572 7.07786 14.531 7.77374 14.6805V15.75H10.2276V14.6805C10.9235 14.531 11.5732 14.2572 12.1521 13.883L12.9075 14.6384L14.642 12.9027L13.8872 12.1479C14.2613 11.569 14.5351 10.9193 14.6846 10.2234H15.7513V7.76958H14.6846Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.5c3668577366a8bf2722ed56370d8042.svg";
export { ForwardRef as ReactComponent };